






















import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class ImageShow extends Vue {
    @Prop({required:true}) src!:string;
    @Prop({required:false,default:""}) showSrc!:string;
    @Prop({required:false,default:"null.jpg"}) downloadString!:string;
    @Prop({default:false}) downloadButton!:boolean;
    @Prop({default:12}) md!:number;
    @Prop({default:"100px"}) maxWidth!:string;
    dialog=false;
    version=1;
    changeVersion(){
        this.version = Math.floor(Math.random() * 100000);
    }
    getSrc(){
        if(this.src.indexOf("magnetMaker/") >= 0)
            return this.$store.getters.siteUrl + this.src + '?v='+this.version;
        else
            return this.$store.getters.imagePath + this.src + '?v='+this.version;
    }
}
